module.exports = __webpack_public_path__ + "media/Images/logo-group-b9210526a8d8fce55e08714e8d574731.png";